import React, { useEffect, useState } from "react";
import Card from "./Card";
import Page from "./Page";
import { atmosphere, documents, material } from "./Items";
import NextButton from "./NextButton";
import Debrief from "./Debrief";
import { sendActivity } from "../../utils/globalUtils";

const EnvironmentChoice = () => {
  const [page, setPage] = useState<number>(0);
  const [showNavigation, setShowNavigation] = useState<boolean>(false);
  const resultContent: any[] = [
    ...(material as any[]).reduce<any[]>((acc, item) => {
      if (item.valid) {
        item.color = "red";
        acc.push(item);
      }
      return acc;
    }, []),
    ...(atmosphere as any[]).reduce<any[]>((acc, item) => {
      if (item.valid) {
        item.color = "blue";
        acc.push(item);
      }
      return acc;
    }, []),
    ...(documents as any[]).reduce<any[]>((acc, item) => {
      if (item.valid) {
        item.color = "purple";
        acc.push(item);
      }
      return acc;
    }, []),
  ];

  const pages = [
    { title: "Le dossier patient", items: documents, color: "purple" },
    { title: "Le matériel", items: material, color: "red" },
    { title: "L'ambiance", items: atmosphere, color: "blue" },
    { title: "Résultats", items: resultContent, color: "green" },
  ];

  useEffect(() => {
    const menu: HTMLElement | null = document.querySelector("#retorik-menu");
    console.log(menu);
    if (menu) menu.style.display = "none";
  }, []);

  useEffect(() => {
    console.log(pages[page].items);
  });

  const gotToNextPage = () => {
    console.log(page, pages[page]);
    if(page == 0){
      //Si page est dossier patient, on envoi un event afin de faire parler le bot
      setTimeout(
        () =>
          sendActivity({
            type: "event",
            name: "CHU_Event_EndDossier_EnvironmentSelection",
          }),
        500
      );
    }
    setPage(page + 1);
    setShowNavigation(false);
  };

  const readDebrief = () => {
    gotToNextPage();
    setTimeout(
      () =>
        sendActivity({
          type: "event",
          name: "CHU_Event_End_EnvironmentSelection",
        }),
      500
    );
  };

  const handleChange = () => {
    const selectedCard = document.querySelector(".ec-card.selected");
    setShowNavigation(!!selectedCard);
  };

  return (
    <div className="ec ec-overlay">
      <Page content={pages[page]} number={page} onChange={handleChange} isDebrief={page === pages.length - 1}>
        {page == 0 && (
          <div className="ec-pdfHint">Après lecture des PDF, n'oubliez-pas de cliquer sur les éléments du dossier patient que vous retenez pour passer à l'étape suivante</div>
        )}
        {showNavigation && (
          <React.Fragment>
            {page < pages.length - 2 && (
              <NextButton onClick={gotToNextPage}>Suivant</NextButton>
            )}
            {page === pages.length - 2 && (
              <NextButton onClick={readDebrief}>Voir les résultats</NextButton>
            )}
          </React.Fragment>
        )}
        {page === pages.length - 1 && <Debrief />}
      </Page>
    </div>
  );
};

export default EnvironmentChoice;
